// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../../services/send.service';

@Injectable()
export class ParallelTaskService {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public subjectShowModal = new BehaviorSubject({});

  public postRequestTask(body, params) {
    const url = this.Global.services.bpmn.parallelRequests();
    return this.sendService.post(url, body, { params });
  }

  public sendParallelRequests(params) {
    const url = this.Global.services.bpmn.sendParallelRequests();
    return this.sendService.post(url, {}, { params });
  }

  public createAndSendParallelRequest(body, params) {
    const url = this.Global.services.bpmn.createAndSendParallelRequest();
    return this.sendService.post(url, body, { params });
  }

  public getParallelHistory(params) {
    const url = this.Global.services.bpmn.getParallelBranches();
    return this.sendService.get(url, { params });
  }

  public getNote(params) {
    const url = this.Global.services.note.getNotesByProcessId();
    return this.sendService.get(url, { params });
  }

  public getHistoricFileById(params) {
    const url = this.Global.services.audience.getHistoricFileById();
    return this.sendService.get(url, { params });
  }

  public getHistoricCourtHearing(params) {
    const url = this.Global.services.audience.getHistoricCourtHearing();
    return this.sendService.get(url, { params });
  }

  public delParallelRequest(params) {
    const url = this.Global.services.bpmn.delParallelRequests();
    return this.sendService.delete(url, { params });
  }
}
